module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_8023.1bcd92e4.png";